// app/redux/actions/avanceActions.js

// =========================
// FETCH ALL
// =========================
export const FETCH_AVANCE_REQUEST = "FETCH_AVANCE_REQUEST";
export const FETCH_AVANCE_SUCCESS = "FETCH_AVANCE_SUCCESS";
export const FETCH_AVANCE_FAIL = "FETCH_AVANCE_FAIL";

// =========================
// GET BY ID
// =========================
export const FETCH_AVANCE_BY_ID_REQUEST = "FETCH_AVANCE_BY_ID_REQUEST";
export const FETCH_AVANCE_BY_ID_SUCCESS = "FETCH_AVANCE_BY_ID_SUCCESS";
export const FETCH_AVANCE_BY_ID_FAIL = "FETCH_AVANCE_BY_ID_FAIL";

// =========================
// CREATE
// =========================
export const CREATE_AVANCE_REQUEST = "CREATE_AVANCE_REQUEST";
export const CREATE_AVANCE_SUCCESS = "CREATE_AVANCE_SUCCESS";
export const CREATE_AVANCE_FAIL = "CREATE_AVANCE_FAIL";

// =========================
// UPDATE
// =========================
export const UPDATE_AVANCE_REQUEST = "UPDATE_AVANCE_REQUEST";
export const UPDATE_AVANCE_SUCCESS = "UPDATE_AVANCE_SUCCESS";
export const UPDATE_AVANCE_FAIL = "UPDATE_AVANCE_FAIL";

// =========================
// DELETE
// =========================
export const DELETE_AVANCE_REQUEST = "DELETE_AVANCE_REQUEST";
export const DELETE_AVANCE_SUCCESS = "DELETE_AVANCE_SUCCESS";
export const DELETE_AVANCE_FAIL = "DELETE_AVANCE_FAIL";

// =========================
// FETCH ACTIFS
// =========================
export const FETCH_AVANCE_ACTIFS_REQUEST = "FETCH_AVANCE_ACTIFS_REQUEST";
export const FETCH_AVANCE_ACTIFS_SUCCESS = "FETCH_AVANCE_ACTIFS_SUCCESS";
export const FETCH_AVANCE_ACTIFS_FAIL = "FETCH_AVANCE_ACTIFS_FAIL";

// =========================
// LOADING / ERROR
// =========================
export const SET_AVANCE_LOADING = "SET_AVANCE_LOADING";
export const CLEAR_AVANCE_ERROR = "CLEAR_AVANCE_ERROR";

// =========================
// ACTION CREATORS
// =========================
export const setAvanceLoading = (loading) => ({
    type: SET_AVANCE_LOADING,
    payload: loading,
});

export const clearAvanceError = () => ({
    type: CLEAR_AVANCE_ERROR,
});

// FETCH ALL
export const fetchAvanceRequest = () => ({ type: FETCH_AVANCE_REQUEST });
export const fetchAvanceSuccess = (data) => ({ type: FETCH_AVANCE_SUCCESS, payload: data });
export const fetchAvanceFail = (error) => ({ type: FETCH_AVANCE_FAIL, payload: error });

// FETCH BY ID
export const fetchAvanceByIdRequest = (id) => ({ type: FETCH_AVANCE_BY_ID_REQUEST, payload: id });
export const fetchAvanceByIdSuccess = (data) => ({ type: FETCH_AVANCE_BY_ID_SUCCESS, payload: data });
export const fetchAvanceByIdFail = (error) => ({ type: FETCH_AVANCE_BY_ID_FAIL, payload: error });

// CREATE
export const createAvanceRequest = (payload) => ({ type: CREATE_AVANCE_REQUEST, payload });
export const createAvanceSuccess = (created) => ({ type: CREATE_AVANCE_SUCCESS, payload: created });
export const createAvanceFail = (error) => ({ type: CREATE_AVANCE_FAIL, payload: error });

// UPDATE
export const updateAvanceRequest = (id, payload) => ({
    type: UPDATE_AVANCE_REQUEST,
    payload: { id, payload }
});
export const updateAvanceSuccess = (updated) => ({ type: UPDATE_AVANCE_SUCCESS, payload: updated });
export const updateAvanceFail = (error) => ({ type: UPDATE_AVANCE_FAIL, payload: error });

// DELETE
export const deleteAvanceRequest = (id) => ({ type: DELETE_AVANCE_REQUEST, payload: id });
export const deleteAvanceSuccess = (id) => ({ type: DELETE_AVANCE_SUCCESS, payload: id });
export const deleteAvanceFail = (error) => ({ type: DELETE_AVANCE_FAIL, payload: error });

// FETCH ACTIFS
export const fetchAvanceActifsRequest = () => ({ type: FETCH_AVANCE_ACTIFS_REQUEST });
export const fetchAvanceActifsSuccess = (data) => ({ type: FETCH_AVANCE_ACTIFS_SUCCESS, payload: data });
export const fetchAvanceActifsFail = (error) => ({ type: FETCH_AVANCE_ACTIFS_FAIL, payload: error });